import { render, staticRenderFns } from "./u-tooltip-elevation-tile-lg.vue?vue&type=template&id=80aa5054&scoped=true&"
import script from "./u-tooltip-elevation-tile-lg.vue?vue&type=script&lang=js&"
export * from "./u-tooltip-elevation-tile-lg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80aa5054",
  null
  
)

export default component.exports